/**
 * Audit Tab Slider - Hover effects and theme switching for audit page
 * Targets #audit-tab-slider with audit-specific color palette
 */
$(document).ready(function () {
  const $auditTabSlider = $('#audit-tab-slider');
  if ($auditTabSlider.length === 0) return;

  const $carouselList = $auditTabSlider.find('.audit-carousel-list');
  const $carouselItems = $auditTabSlider.find('.audit-carousel-item');

  const el = $auditTabSlider.get(0);
  const cs = window.getComputedStyle(el);
  const originalBackground = cs.getPropertyValue('--audit-themed-background').trim();
  const originalForeground = cs.getPropertyValue('--audit-themed-foreground').trim();

  /* Audit page color palette - dark theme variants */
  const auditProjectThemes = [
    { background: '#fff', foreground: '#0f0f0f' },  /* Default audit dark */
    { background: '#fff', foreground: '#0f0f0f' },  /* Slightly lighter */
    { background: '#fff', foreground: '#0f0f0f' }   /* Medium dark */
  ];

  $auditTabSlider.find('.audit-project-item').on('mouseenter', function () {
    const index = $(this).data('index');

    $carouselList.css('transform', `translateX(-${index * 650}px)`);
    $carouselItems.css('transform', 'rotate(-22.5deg) scale(1.1, 1.1)');

    if (index < auditProjectThemes.length) {
      $auditTabSlider.css('--audit-themed-background', auditProjectThemes[index].background);
      $auditTabSlider.css('--audit-themed-foreground', auditProjectThemes[index].foreground);
    }
  });

  $auditTabSlider.find('.audit-project-list').on('mouseleave', function () {
    $carouselList.css('transform', 'translateX(0)');
    $carouselItems.css('transform', 'translateX(0) rotate(-30deg)');

    $auditTabSlider.css('--audit-themed-background', originalBackground);
    $auditTabSlider.css('--audit-themed-foreground', originalForeground);
  });

  $auditTabSlider.find('.audit-project-item a').on('click', function (e) {
    e.stopPropagation();
  });

  function handleHashActivation() {
    const hash = window.location.hash;
    if (!hash) return;

    const targetElement = $(hash);
    if (targetElement.length === 0) return;

    if (targetElement.hasClass('audit-project-item')) {
      const $subtitle = targetElement.find('.audit-project-subtitle');
      if ($subtitle.length === 0) return;

      $auditTabSlider.find('.audit-project-subtitle.is-active').removeClass('is-active');
      
      $subtitle.addClass('is-active');
      $auditTabSlider.addClass('has-active-subtitle');

      setTimeout(function() {
        const offset = 100;
        $('html, body').animate({
          scrollTop: targetElement.offset().top - offset
        }, 500);
      }, 100);
    }
  }

  handleHashActivation();

  $(window).on('hashchange', function() {
    handleHashActivation();
  });
});
